/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/tabindex-no-positive */
/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
/* eslint-disable react/jsx-no-bind */
import React, { useEffect, useMemo, useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import ReactGA from "react-ga4";
import { useDispatch } from "react-redux";

// design
import "./navbar.scss";

// imgs
import { ReactComponent as HamMenu } from "design_system/src/static/icons/hamburger-menu.svg";
import { ReactComponent as Money } from "design_system/src/static/icons/money.svg";

import { Button, ScalableImage } from "design_system/src";
import {
  clearApplicationLoanTime,
  clearApplicationPartnership,
  clearApplicationVehicle,
} from "store/actions/application";
import {
  AllianceEnum,
  AllianceUrlEnum,
  CATALOG_ALLIANCES,
  getAlliance,
  getAllianceUrl
} from "enums/alliance.enum";
import { Cities } from "../../../store/reducers/cityReducer";

type NavbarProps = {
  setOpenCityModal: Function;
};
export const Navbar: React.FC<NavbarProps> = ({ setOpenCityModal }) => {
  const dispatch = useDispatch();

  const location = useLocation();
  const [sideBar, setSideBar] = useState<boolean>(false);
  const [url, setURL] = useState("");

  const alliance = useMemo<AllianceEnum | null>(() => {
    const match = location.pathname.match(/^\/([^/]+)\/(financia-tu-moto|catalogo(?:\/[^/]*)?)$/);

    if (match) {
      const alianza = match[1];
      const allianceValue = getAlliance(alianza as AllianceUrlEnum);
      if (allianceValue) {
        return allianceValue;
      }
    }

    return null;
  }, [location.pathname]);


  const formUrl = useMemo<string>(() => {
    if (alliance) return `${getAllianceUrl(alliance)}/financia-tu-moto`;
    return "/financia-tu-moto";
  }, [alliance]);

  const paths = useMemo<any[]>(
    () => {
      if (alliance && CATALOG_ALLIANCES.includes(alliance)) {
        return [];
      }

      return [
        {
          path: "/catalogo",
          label: "Compra tu moto",
        },
        // Temporal: Vende tu moto off — descomentar junto con handleSidebar abajo y las rutas.
        // {
        //   path: "/vende-tu-moto",
        //   label: "Vende tu moto",
        // },
        {
          path: "/nosotros",
          label: "Nosotros",
        },
        {
          path: "/referidos",
          label: "Referidos",
        },
        {
          path: "/faqs",
          label: "Ayuda",
        },
      ];
    },
    [alliance]
  );

  useEffect(() => {
    setURL(location.pathname);
  }, [location.pathname]);

  function toggleSideBar() {
    setSideBar(!sideBar);
  }

  function handleSidebar(selectedSection: string) {
    // if (selectedSection === "/vende-tu-moto") {
    //   ReactGA.event("CTA_Header_sell_bike", {
    //     category: "Ozocio",
    //     label: "click in sell your bike btn in web header view",
    //   });
    // } else
    if (selectedSection === "/faqs") {
      ReactGA.event("CTA_navbar_FAQS", {
        category: "Support",
        label: "click faqs from navbar to FAQS view",
      });
    } else if (selectedSection === "/catalogo") {
      ReactGA.event("CTA_catalog_navbar", {
        category: "Marketplace",
        label: "click catalog from navbar to catalog view",
      });
    } else {
      ReactGA.event("CTA_navbar_icon", {
        category: "Support",
        label: "click ozon´s icon button to home view (/)",
      });
    }
  }

  const city = localStorage.getItem("city");

  useEffect(() => {
    if (city !== Cities.CDMX) {
      localStorage.setItem("city", Cities.CDMX);
    }
  }, [city]);

  const goLoan = () => {
    dispatch(clearApplicationLoanTime());
    dispatch(clearApplicationVehicle());
    dispatch(clearApplicationPartnership());
  };

  return (
    <div
      className="pos_fixed display_block"
      style={{ zIndex: 999, width: "100%" }}
    >
      <header className="navbar shadow_medium ">
        <div className="main-container">
          <div
            className="display_flex"
            style={{ justifyContent: "start", alignItems: "center" }}
          >
            <Link to="/" className="custom_a">
              <figure className="m_none">
                <ScalableImage
                  src="https://ik.imagekit.io/ozon/Compartidos/Logos/logo_ozon"
                  alt="Ozon - Compra y financia tu moto en Ciudad de México"
                  className="h_xl"
                  desktopWidth={5}
                  mobileWidth={5}
                />
              </figure>
            </Link>
          </div>

          {(!alliance || !location.pathname.includes("financia-tu-moto")) && <Button
            className="display_none_desktop"
            variant="icon"
            scale="small"
            subvariant="edit"
            icon={<HamMenu />}
            onClick={toggleSideBar}
          />}
          <div
            className={`backdrop display_none_desktop ${sideBar ? "open" : ""}`}
            onClick={toggleSideBar}
            tabIndex={0}
          >
            <div className="sidebar" tabIndex={1}>
              <Link to="/" className="custom_a">
                <figure className="m_none">
                  <ScalableImage
                    src="https://ik.imagekit.io/ozon/Compartidos/Logos/logo_ozon"
                    alt="Ozon - Compra y financia tu moto en Ciudad de México"
                    className="m_y_xxxl center_x h_xl"
                    desktopWidth={5}
                    mobileWidth={5}
                  />
                </figure>
              </Link>

              <nav className="flex_center_col flex_align_start p_xxl ">
                <div
                  className="dim_100_per flex_center flex_col m_b_xs p_b_xl w_100_per"
                  style={{ borderBottom: "1px solid #E0E3E5" }}
                >
                  {!alliance && <Link
                    to="/mi-cuenta"
                    onClick={goLoan}
                    className="m_b_sm w_100_per"
                  >
                    <Button
                      variant="ghost"
                      scale="small"
                      className="w_100_per bg_primary_25 text_primary_300"
                    >
                      Mi cuenta
                    </Button>
                  </Link>}

                  <Link
                    to={formUrl}
                    onClick={goLoan}
                    className="custom_a w_100_per"
                  >
                    <Button
                      variant="principal"
                      color="primary"
                      icon={<Money />}
                      scale="small"
                      className="w_100_per"
                    >
                      Solicita tu crédito ya
                    </Button>
                  </Link>
                </div>
                {paths.map((ele) => {
                  return (
                    <Link
                      to={ele.path}
                      onClick={() => handleSidebar(ele.path)}
                      key={ele.path}
                      className="custom_a"
                    >
                      <Button
                        variant="link"
                        className={`${ele.path === url ? "active" : ""} m_b_md`}
                        scale="small"
                      >
                        {ele.label}
                      </Button>
                    </Link>
                  );
                })}
              </nav>
            </div>
          </div>
          <nav className="flex_center flex_justify_end flex_grow_1 display_none_mobile pos_relative">
            {paths.map((ele) => {
              return (
                <Link
                  to={ele.path}
                  onClick={() => handleSidebar(ele.path)}
                  key={ele.path}
                  className="custom_a"
                >
                  <Button
                    variant="link"
                    className={`${
                      ele.path === url ? "m_r_xxxl active" : "m_r_xxxl"
                    }`}
                    scale="small"
                  >
                    {ele.label}
                  </Button>
                </Link>
              );
            })}

            {(!alliance || !location.pathname.includes("financia-tu-moto")) && <>
              <Link
                to={formUrl}
                onClick={goLoan}
                className="custom_a"
              >
                <Button
                  variant="principal"
                  color="primary"
                  icon={<Money />}
                  onClick={goLoan}
                  scale="small"
                >
                  Solicita tu crédito ya
                </Button>
              </Link>

              {!alliance && <Link
                to="/mi-cuenta"
                onClick={goLoan}
                className="m_l_sm"
              >
                <Button
                  color="primary"
                  variant="ghost"
                  scale="small"
                  className="w_100_per bg_primary_25 text_primary_300"
                >
                  Mi cuenta
                </Button>
              </Link>}
            </>}
          </nav>
        </div>
      </header>
    </div>
  );
};
